import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {useEffect, useState} from 'react'
import {BoardSettingsPage} from '@components/board/board-settings/board-settings-store'
import {useBoard} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {TaskTemplatesEdit} from './task-templates-edit'
import {TaskTemplatesExistence} from './task-templates-existence'
import {TaskTemplatesMain} from './task-templates-main'
import {
  TaskTemplatesContext,
  TaskTemplatesStore,
  useTaskTemplatesStore
} from './task-templates-store'

interface Props {
  defaultPage?: BoardSettingsPage
}
export const TaskTemplatesRouter = observer((props: Props) => {
  const {defaultPage} = props
  const [state, store] = useTaskTemplatesStore()

  useEffect(() => {
    if (defaultPage === 'create') {
      store.goToCreate()
    }
    if (defaultPage === 'list') {
      // store.goToMain()
    }
  }, [defaultPage])

  if (state.page === 'main') {
    return <TaskTemplatesMain />
  }

  if (state.page === 'create') {
    return <TaskTemplatesEdit />
  }

  if (state.page === 'edit') {
    return <TaskTemplatesEdit />
  }

  if (state.page === 'existence') {
    return <TaskTemplatesExistence />
  }

  return null
})

export const TaskTemplates = (props: Props) => {
  const board = useBoard()

  const companyId = globals.getCompanyId()

  const [store] = useState(() => new TaskTemplatesStore(companyId, board.id))

  return (
    <TaskTemplatesContext.Provider value={store}>
      <TaskTemplatesRouter {...props} />
    </TaskTemplatesContext.Provider>
  )
}
